import './submodules.css';

// Sub modules
export function FruitLips() {
  return (
    <div className='fruit-lips-container'>
      <iframe 
        title='fruit-lips'
        className='fruitLips'
        src="./fruit-lips/src/fruit-lips.html"
        width="100%"
        height="100%"
      />
    </div>
  );
}

export function FruitLips2() {
  return (
    <div className='fruit-lips2-container'>
      <iframe 
        title='fruit-lips'
        className='fruitLips'
        src="./fruit-lips/src2/fruit-lips2.html"
        width="100%"
        height="100%"
      />
    </div>
  );
}

export function FruitLips3() {
  return (
    <div className='fruit-lips3-container'>
      <iframe 
        title='fruit-lips'
        className='fruitLips'
        src="./fruit-lips/src3/fruit-lips.html"
        width="100%"
        height="100%"
      />
    </div>
  );
}

export function ShortStorey() {
  return (
    <div className='shortstorey-container'>
      <iframe 
        title='shortstorey'
        className='shortStorey'
        src="./shortstorey-full/frontend/dist/index.html"
        width="100%"
        height="100%"
      />
    </div>
  );
}

export function SpotifyRouletteIframe() {
  return (
    <div className='spotify-roulette-container'>
      <iframe 
        title='spotify-roulette'
        className='spotifyRoulette'
        src={'./spotify-roulette/frontend/build/index.html' + window.location.search}
        width="100%"
        height="100%"
      />
    </div>
  );
}

export function Squares() {
  return (
    <div className='squares-container'>
      <iframe 
        title='368Squares'
        className='368Squares'
        src="./squares/frontend/squares.html"
        width="100%"
        height="100%"
      />
    </div>
  );
}

export function LLMCompare() {
  return (
    <div className='llm-compare-container'>
      <iframe 
        title='LLMCompare'
        data-class='llmCompare'
        className='llmCompare'
        src="./llm-compare/src/index.html"
        width="100%"
        height="100%"
      />
    </div>
  );
}

export function BerkoLitterPick() {
  return (
    <div className='berko-litter-pick-container'>
      <iframe 
        title='berko-litter-pick'
        src="./litter-pick/frontend/public/index.html"
        width="100%"
        height="100%"
      />
    </div>
  );
}